import isServer from '@anm/helpers/is/isServer';

import { I18N_DATA_NAME } from './components/I18nHead';

export type Data = { [key in string]: unknown };

const dataFromHTML = !isServer() && JSON.parse(document.getElementById(I18N_DATA_NAME)?.innerText || '{}');
const i18nData: Data = dataFromHTML || {};

export default i18nData;
